import type { ReactNode } from "react"
import { Info } from "lucide-react"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"
import { cn } from "@/lib/utils"

interface InfoTipProps {
	content: string | ReactNode
	side?: "top" | "right" | "bottom" | "left"
	className?: string
}

export function InfoTip({ content, side = "top", className }: InfoTipProps) {
	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<button
					type="button"
					aria-label="More information"
					className={cn("inline-flex items-center focus:outline-none", className)}
				>
					<Info className="h-3.5 w-3.5 text-muted-foreground/60 hover:text-muted-foreground transition-colors" />
				</button>
			</TooltipTrigger>
			<TooltipContent side={side} className="max-w-xs text-xs leading-relaxed">
				{content}
			</TooltipContent>
		</Tooltip>
	)
}
